import React, { useState } from 'react';
import { CalendarDays, ChevronDown, FileText, MapPin } from 'lucide-react';
import { date } from '../api';
import { DownloadButton, Status } from '../ui';
import { QuoteSummary } from '../QuoteForms';
import { RequestActions } from './RequestActions';

const RequestHeader = ({ rfq, user, open, toggle }) => <button data-testid={`rfq-expand-${rfq.id}`}
  className="request-top" onClick={toggle} aria-expanded={open}>
  <span className="request-icon"><FileText size={21} /></span>
  <span className="request-info"><strong>{rfq.number}</strong>
    <span>{user.role === 'supplier' ? rfq.buyer_company : rfq.supplier_name}</span></span>
  <span className="request-meta"><span>{rfq.items.length} product{rfq.items.length !== 1 ? 's' : ''}</span><small>{date(rfq.created_at)}</small></span>
  <Status value={rfq.status} id={`rfq-status-${rfq.id}`} /><ChevronDown size={17} className={open ? 'rotate' : ''} />
</button>;

const RequestRequirements = ({ rfq }) => <>
  <div className="rfq-context">
    <span><MapPin size={16} />{rfq.destination}, {rfq.pincode}</span>
    <span><CalendarDays size={16} />{rfq.timeline}{rfq.sample && ' · Sample request'}</span>
  </div>
  <div className="table-scroll"><table data-testid={`rfq-items-${rfq.id}`}>
    <thead><tr><th>Product</th><th>SKU</th><th>Quantity</th></tr></thead>
    <tbody>{rfq.items.map(item => <tr key={item.product_id}><td>{item.name}</td>
      <td className="mono">{item.sku}</td><td>{item.quantity} {item.unit}</td></tr>)}</tbody>
  </table></div>
  {rfq.notes && <p className="request-notes">{rfq.notes}</p>}
  <div className="request-files">{rfq.attachment_ids.map((fileId, index) => <DownloadButton key={fileId}
    id={`rfq-attachment-${rfq.id}-${index}`} path={`/files/${fileId}`} name={`rfq-attachment-${index + 1}`}>
    Attachment {index + 1}
  </DownloadButton>)}</div>
</>;

export const RequestItem = ({ rfq, user, reload }) => {
  const [open, setOpen] = useState(false);
  return <article className="request-item" data-testid={`rfq-record-${rfq.id}`}>
    <RequestHeader rfq={rfq} user={user} open={open} toggle={() => setOpen(current => !current)} />
    {open && <div className="request-expanded">
      <RequestRequirements rfq={rfq} />
      {rfq.quote && <QuoteSummary quote={rfq.quote} id={rfq.id} />}
      <RequestActions rfq={rfq} user={user} reload={reload} />
    </div>}
  </article>;
};